<template>
  <div class="requestlistheader global__bc_blue">
    <div v-if="isLoadingDetail"
      class="spinner__medium--white d-flex align-items-center
      justify-content-center" style="height: 250px">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-if="detail" class="row m-0">
      <div  class="row m-0 w-100">
        <div class="col-md-2 requestlistheader__block1">
          <div class="back__button" @click="backToPrevious()">
            <img src="@/assets/image/icon/arrow-back-full-yellow.svg" alt="">
            <span class="pl-2">Back</span>
          </div>
          <div class="row m-0 my-1 align-items-center">
            <h5 class="pl-2">Instant Quote</h5>
          </div>
          <p style="padding-left: 0.5rem !important;">{{getDateFormat1(detail.bannerInfo.createdAt)}}</p>
        </div>
        <div class="col-md-5 requestlistheader__block2 border_blue my-auto">
          <div class="row m-0">
            <p class="col-md-1 p-0">Route</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0"> {{ detail.bannerInfo.originDestination }}</p>
          </div>
          <div class="row m-0">
            <p class="col-md-1 p-0">Instant Quote Number</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0"> {{ detail.bannerInfo.requestNumber }}</p>
          </div>
        </div>
        <div class="col-md requestlistheader__block3 border_blue my-auto">
          <div class="flex row ml-1">
            <p class="col-md-3 p-0">Shipment Service</p><span class="col-md-0 px-1">:</span>
            <p class="col-md p-0">{{ getServiceType(detail.bannerInfo.shipmentService)}}</p>
          </div>
          <div class="flex row ml-1">
            <p class="col-md-3 p-0">Shipment Type</p> <span class="col-md-0 px-1">:</span>
            <p class="col-md p-0">
              {{detail.bannerInfo.shipmentType}}
            </p>
          </div>
          <div class="flex row ml-1">
            <p class="col-md-3 p-0">Shipment Date</p> <span class="col-md-0 p-0 px-1">:</span>
            <p class="col-md p-0" v-if="detail.bannerInfo.shipmentDate !== '-'">{{ getDateDefauld(detail.bannerInfo.shipmentDate) }}</p>
            <p class="col-md p-0" v-else>-</p>
          </div>
        </div>
        <div class="col-md requestlistheader__block4 border_blue">
          <div>
            <p class="">Status:</p>
            <h6 class="my-auto">{{detail.bannerInfo.status === 'ONGOING' ? 'Ready to Book' : detail.bannerInfo.status}}</h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinShipmentDetails from '@/mixin/getters/shipment-details'
import mixinDateTime from '@/mixin/getters/date-time'
import mixinGetStatus from '@/mixin/getters/status-bid'
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderBox',
  mixins: [mixinGetStatus, mixinShipmentDetails, mixinDateTime],
  computed: {
    ...mapGetters({
      detail: 'instantQuote/iqDetail',
      isLoadingDetail: 'instantQuote/isLoadingIqDetail',
      errorDetail: 'instantQuote/errorIqDetail'
    })
  },
  methods: {
    fetchIq () {
      const id = this.$route.params.id_iq
      this.$store.dispatch('instantQuote/FETCH_IQ_BY_ID', id)
    },
    reloadWindow () { // ntar ke mixin global
      window.location.reload()
    },
    getImageShipment (type) {
      if (type === 'OCEAN') {
        return require('@/assets/image/icon/shipment-ocean.svg')
      } else if (type === 'LAND') {
        return require('@/assets/image/icon/shipment-land.svg')
      }
      return require('@/assets/image/icon/shipment-air.svg')
    },
    backToPrevious () {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'RequestList', params: { type: 'instant-quote' } })
      }
    }
  },
  watch: {
    detail (data) {
      if (data) {
        this.datas = data
        this.isLoading = false
        // console.log('data header', this.datas);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail-instant-quote/HeaderBox.vue